import React from 'react';
import { connect } from 'react-redux';
import { Row, Col, Panel } from 'react-bootstrap';
import AssignmentPropTypes from '../assignment_prop_types';

import AssignmentRequirements from './assignment_requirements';
import ContractDetails from './contract_details';

export class RequirementsCard extends React.Component {
  static propTypes = {
    ...AssignmentPropTypes
  };

  render() {
    return (
      <Panel className="p-5">
        <Panel.Heading className="pb-0">
          <Row>
            <Col sm={6}>
              <Panel.Title componentClass="h3">
                <span>Requirements</span>
              </Panel.Title>
            </Col>
          </Row>
        </Panel.Heading>
        <Panel.Body>
          <AssignmentRequirements assignment={this.props.assignment}/>
        </Panel.Body>
        {["Under Contract", "Closed"].includes(this.props.assignment.status) &&
          <React.Fragment>
            <Panel.Heading className="pb-0">
              <Row>
                <Col sm={6}>
                  <Panel.Title componentClass="h3">
                    <span>Contract Details</span>
                  </Panel.Title>
                </Col>
              </Row>
            </Panel.Heading>
            <Panel.Body>
              <ContractDetails assignment={this.props.assignment}/>
            </Panel.Body>
          </React.Fragment>
        }
      </Panel>
    );
  }
}

function mapStateToProps({ assignment }) {
  return { assignment };
}

export default connect(mapStateToProps)(RequirementsCard);
